export default __webpack_public_path__ + "static/media/CRAFT.142b3bb7.png";